import React from 'react';
import {Link} from 'react-router-dom';

// components
import Header from './Header';
import Footer from './Footer';

class NotFound extends React.Component {
  render() {
    return (
      <div>
        <Header currentPage={this.props.currentPage} pages={this.props.pageData} />
        <h2>Not Found!</h2>
                <Footer blogInfo={this.props.blogInfo} />
      </div>
      
    )
  }
}

export default NotFound;


// WEBPACK FOOTER //
// ./src/components/NotFound.js